/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect } from "react";
import * as styles from "./styles.module.scss";
import cx from "classname";
import SiteGutter from "../SiteGutter";
import { useEscape } from "../../effects/useKeyPress";
import Link from "../Link";
import useLogin from "../../effects/useLogin";

function MobileMenu({ links, logIn }) {
  const [isVisible, setVisible] = useState(false);
  const login = useLogin();

  // TODO: Replace with Auth0 logic
  const isAuthenticated = false;

  const closeMenu = () => {
    window.dispatchEvent(new CustomEvent("toggleMobileMenu"));
  };

  useEffect(() => {
    const toggler = () => {
      setVisible(!isVisible);
    };
    window.addEventListener("toggleMobileMenu", toggler);
    return () => window.removeEventListener("toggleMobileMenu", toggler);
  }, [isVisible]);

  const handleEscape = () => {
    if (!isVisible) {
      return;
    }
    closeMenu();
  };

  const handleClick = (e) => {
    if (e.target.dataset.overlay) {
      closeMenu();
    }
  };

  const handleKeyboardEscape = (e) => {
    if (e.key === "Escape") {
      closeMenu();
    }
  };

  useEscape(handleEscape);

  if (!isVisible) {
    return null;
  }

  return (
    <div
      className={styles.container}
      onClick={handleClick}
      onKeyUp={handleKeyboardEscape}
      aria-modal="true"
      data-overlay
    >
      <div className={styles.flyout}>
        <SiteGutter>
          <button className={styles.close} onClick={closeMenu}>
            <svg
              width="28"
              height="28"
              viewBox="0 0 28 28"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <title>Close</title>
              <line
                x1="22.4003"
                y1="22.5072"
                x2="5.60004"
                y2="5.70689"
                stroke="black"
                strokeWidth="2"
              />
              <line
                x1="5.59953"
                y1="22.2929"
                x2="22.3998"
                y2="5.49262"
                stroke="black"
                strokeWidth="2"
              />
            </svg>
          </button>
          <ul className={styles.navigation}>
            {links.map(({ url, label }) => (
              <li key={label}>
                <Link
                  url={url}
                  label={label}
                  onClick={closeMenu}
                  className={styles.navLink}
                />
              </li>
            ))}
          </ul>
          {!isAuthenticated && (
            <button
              onClick={login}
              className={cx(styles.loginButton, "button white mobileFull")}
            >
              {logIn.label}
            </button>
          )}
        </SiteGutter>
      </div>
    </div>
  );
}

export default MobileMenu;
